import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/common/Accordion';
import Header from '@/components/layout/Header';
import { ROUTES } from '@/configs/constants';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import ExsampleImage1 from '@/assets/images/pngs/term_image_1.png';
import { useNavigate } from 'react-router-dom';
import ShowItem from './components/index';

export default observer(function HowToUsePage() {
    // store
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start bg-white pt-[72px] min-h-screen pb-[env(safe-area-inset-bottom)] overflow-y-auto'>
            <Header goBackFunction={goBack} title={t('text.faq')} />
            <div className='max-w-4xl mx-auto px-6 space-y-8 text-gray-800 pb-8'>
                {/* 1. Giới thiệu */}
                <section>
                    <h2 className='text-2xl font-bold mb-2'>🎯 「omikuji」って何？</h2>
                    <p className='mb-2'>
                        「omikuji」は、地図上に配置されたデジタルアイテムを、実際の位置で取得できるWebアプリです！
                        近くのアイテムを探して、対象エリアでスマホを振るだけで、お得なクーポンや特別なデジタルアイテムをゲットできます。
                    </p>
                </section>

                {/* 2. Ví dụ về item */}
                <section>
                    <h3 className='text-xl font-semibold mb-2'>📌 例えばこんなアイテムが手に入る！</h3>
                    <ul className='list-disc pl-6 space-y-1'>
                        <li>✅ 飲食店の割引クーポン</li>
                        <li>✅ 観光施設の限定デジタルフォト</li>
                        <li>✅ 特定エリアでしか手に入らないシークレットアイテム</li>
                    </ul>
                </section>

                {/* 3. Tính năng chính (hướng dẫn từng bước) */}
                <section>
                    <h3 className='text-xl font-semibold mb-4'>🏆 「omikuji」でできること</h3>
                    <div className='space-y-4'>
                        <div>
                            <h4 className='font-semibold'>1️⃣ 地図でデジタルアイテムを探す</h4>
                            <p>アプリを開くと、近くにあるアイテムが地図上に表示されます！</p>
                        </div>
                        <div>
                            <h4 className='font-semibold'>2️⃣ エリアでスマホを振るだけ！</h4>
                            <p>アイテムがあるエリア内で、スマートフォンを振ると取得可能🎶</p>
                        </div>
                        <div>
                            <h4 className='font-semibold'>3️⃣ アイテムをコレクション＆シェア</h4>
                            <p>取得したデジタルアイテムはアプリ内で管理でき、SNSでシェアも可能✨</p>
                        </div>
                    </div>
                </section>

                {/* 4. Đối tượng phù hợp */}
                <section>
                    <h3 className='text-xl font-semibold mb-2'>🌟 「omikuji」はこんな人におすすめ！</h3>
                    <ul className='list-disc pl-6 space-y-1'>
                        <li>✔ 街歩きをもっと楽しくしたい！</li>
                        <li>✔ ARや位置情報を活用した新体験を試したい！</li>
                        <li>✔ お得なクーポンや限定アイテムを手に入れたい！</li>
                    </ul>
                </section>

                {/* 5. Inbound - dành cho khách du lịch */}
                <section>
                    <h3 className='text-xl font-semibold mb-2'>🌍 訪日観光客にもおすすめ！</h3>
                    <ul className='list-disc pl-6 space-y-1'>
                        <li>✅ 観光スポットや飲食店で限定クーポン配布</li>
                        <li>✅ 言語不要！スマホを振るだけの簡単操作</li>
                        <li>✅ 日本文化を感じる「おみくじ」要素も！</li>
                    </ul>
                </section>

                {/* 6. Feedback */}
                <section>
                    <h3 className='text-xl font-semibold mb-2'>📢 ユーザーの声</h3>
                    <div className='space-y-2'>
                        <p>🗣 「街歩きが楽しくなりました！」（30代女性）</p>
                        <p>🗣 「お店のクーポンをゲットしてお得に買い物できました！」（20代男性）</p>
                    </div>
                </section>

                {/* 7. CTA */}
                <section className='bg-yellow-100 border border-yellow-300 p-6 rounded-xl text-center space-y-2'>
                    <h3 className='text-2xl font-bold'>🎉 今すぐ「omikuji」を体験しよう！</h3>
                    <p className='text-lg'>「スマホを振って、デジタルアイテムをゲット！」</p>
                    <a
                        href='https://omikuji.jp'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='inline-block bg-yellow-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-yellow-500 transition'
                    >
                        📍 無料で始める →
                    </a>
                </section>
            </div>
        </div>
    );
});
